
<div class="dashboard-container" *ngIf="userData.user_type=='HQ'">
	<!-- Navigation Tabs -->
	<mat-tab-group class="dashboard-tabs">
		<mat-tab>
			<ng-template mat-tab-label>
				<span class="tab-label-full">HQ Dashboard</span>
				<span class="tab-label-short">HQ</span>
			</ng-template>
			<app-hq-dashboard></app-hq-dashboard>
		</mat-tab>
		<mat-tab>
			<ng-template mat-tab-label>
				<span class="tab-label-full">DT Dashboard</span>
				<span class="tab-label-short">DT</span>
			</ng-template>
			<app-dt-dashboard></app-dt-dashboard>
		</mat-tab>
	</mat-tab-group>
</div>
<div class="dashboard-container" *ngIf="userData.user_type!='HQ'">
	<app-hq-dashboard></app-hq-dashboard>
</div>